import { render, staticRenderFns } from "./DetailsBody.vue?vue&type=template&id=a5f3aa78&scoped=true"
import script from "./DetailsBody.vue?vue&type=script&lang=js"
export * from "./DetailsBody.vue?vue&type=script&lang=js"
import style0 from "./DetailsBody.vue?vue&type=style&index=0&id=a5f3aa78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5f3aa78",
  null
  
)

export default component.exports